export interface RolePermission {
  action: string;
  description: string;
  feature: string;
  id: number;
  is_active: boolean;
  name: string;
  is_assigned: boolean;
}

export interface RolesResponse {
  id: RoleId;
  name: string;
  display_name: string;
  is_active: boolean;
  permissions: RolePermission[];
}

export enum RoleId {
  ADMINISTRATOR = 1,
  MANAGER = 2,
  ANALYST = 3,
  INSPECTOR = 4,
  VIEWER = 5,
}
